import Swal from 'sweetalert2';

// Muestra el error de guardado.
export function notifyModuleError(err: any) {
    Swal.fire({ icon: 'error', title: 'Error', text: errorText(err) });
}

// Lee el texto de error del backend.
export function errorText(err: any) {
    return fallbackText(err.error);
}

// Devuelve el texto o el mensaje base.
export function fallbackText(nested: any) {
    if (nested) return nested.error || 'No se pudo guardar';
    return 'No se pudo guardar';
}
